<template>
    <a-modal :visible="visible" :title="$t('program.repeat_list_modal.title' /* 重复任务列表 */)" width="80%" :maskClosable="false" :footer="null" @cancel="handleCancel">
        <a-spin :spinning="loading">
            <a-table v-if="visible" bordered :rowKey="record => record.id" :columns="columns" :data-source="dataSource" :pagination="false" size="small" :scroll="{ x: 1200 }">
                <template slot="real_name" slot-scope="text, record">
                    {{ record.real_name }}
                    <a-tag color="#108ee9" v-if="record.is_current">{{ $t('program.repeat_list_modal.current_task' /* 当前任务 */) }}</a-tag>
                </template>
                <template slot="time" slot-scope="text, record">{{ record.starttime_slot }} - {{ record.endtime_slot }}</template>
                <template slot="abstract_title" slot-scope="text, record">
                    {{ $route.params.lang == 'cn' ? record.abstract_title : record.abstract_title_en }}
                </template>
            </a-table>
        </a-spin>
    </a-modal>
</template>
<script>
export default {
    name: 'RepeatDutyListModal',
    data() {
        return {
            visible: false,
            loading: false,
            columns: [
                {
                    title: this.$t('program.repeat_list_modal.name' /* 姓名 */),
                    scopedSlots: { customRender: 'real_name' },
                    width: 150
                },
                {
                    title: this.$t('program.repeat_list_modal.org_cnname' /* 单位 */),
                    dataIndex: 'org_cnname',
                    width: 200,
                    align: 'center'
                },
                {
                    title: this.$t('program.repeat_list_modal.date' /* 日期 */),
                    dataIndex: 'meeting_date',
                    width: 100,
                    align: 'center'
                },
                {
                    title: this.$t('program.repeat_list_modal.time' /* 时间 */),
                    scopedSlots: { customRender: 'time' },
                    width: 150,
                    align: 'center'
                },
                {
                    title: this.$t('program.repeat_list_modal.hall' /* 会场 */),
                    dataIndex: 'meeting_hall',
                    width: 120,
                    align: 'center'
                },
                {
                    title: this.$t('program.repeat_list_modal.session' /* Session */),
                    dataIndex: 'session_title',
                    width: 150,
                    align: 'center'
                },
                {
                    title: this.$t('program.repeat_list_modal.task' /* 任务 */),
                    dataIndex: 'typename_cn',
                    width: 100,
                    align: 'center'
                },
                {
                    title: this.$t('program.repeat_list_modal.abstract_title' /* 主题 */),
                    scopedSlots: { customRender: 'abstract_title' },
                    align: 'center',
                    width: 150
                }
            ],
            dataSource: []
        };
    },
    methods: {
        show(data) {
            this.visible = true;
            this.getList({ userid: data.userid, dutyid: data.id });
        },
        handleCancel() {
            this.visible = false;
        },
        getList(queryData) {
            this.loading = true;
            this.$request
                .get({ url: 'getProgramRepeatList', data: queryData })
                .then(res => {
                    if (Array.isArray(res.data)) {
                        res.data.forEach(item => {
                            item.is_current = item.id == queryData.dutyid; // 是否是当前任务
                        });
                    }
                    this.dataSource = res.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
<style lang="less" scoped>
:deep(.ant-table-thead) {
    background: #fafafa;
}
</style>